/** Mirrors `AnnieName` in backend/models/annie_avatar.py: the name reaches Annie's prompt, so it stays a name. */
export const ANNIE_NAME_MAX_LENGTH = 24;
// Letters, combining marks and decimal digits in any script (राम, มิ้น, José); a word starts with a letter or digit.
// Separators: one space, period, hyphen, or apostrophe (' ’ and the Hebrew geresh ׳, as in ג׳וי).
const ANNIE_NAME_WORD = String.raw`[\p{L}\p{Nd}][\p{L}\p{M}\p{Nd}]*`;
const ANNIE_NAME_PATTERN = new RegExp(String.raw`^${ANNIE_NAME_WORD}(?:(?:\.? |[.'’׳-])${ANNIE_NAME_WORD})*\.?$`, "u");

/**
 * What Save sends: NFC with spaces tidied. An unchanged name saves as it was, even when it matches the
 * current language's standard name; otherwise empty or the standard name is null (the standard name).
 */
export const toSavedAnnieName = (draft: string, defaultName: string, saved: string | null): string | null => {
	const name = draft.normalize("NFC").trim().replace(/\s+/g, " ");
	if (name === saved) return saved;
	return name === "" || name === defaultName ? null : name;
};

/** Length in code points, as the backend counts it. */
export const isValidAnnieName = (name: string | null): boolean => name === null || ([...name].length <= ANNIE_NAME_MAX_LENGTH && ANNIE_NAME_PATTERN.test(name));
